import { render, staticRenderFns } from "./NewTalents.vue?vue&type=template&id=6d523af9&scoped=true"
import script from "./NewTalents.vue?vue&type=script&lang=js"
export * from "./NewTalents.vue?vue&type=script&lang=js"
import style0 from "./NewTalents.vue?vue&type=style&index=0&id=6d523af9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d523af9",
  null
  
)

export default component.exports